export function isError(field) {
  if (this.errors[field]) {
    return this.dirty
      ? this.touched.hasOwnProperty(field) && this.touched[field]
      : this.touched.hasOwnProperty(field);
  }
  return false;
}
